const format = {
  area: (n) => `${n} kvm`,
  roomCount: (n) => `${n} rum`,
  rent: (n) => `${n} kr/mån`,
  floor: (n) => (n === -100 ? 'bottenvåning' : `vån ${n}`),
  constructionYear: (n) => `byggår ${n}`
}

export default format
